import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { clearAuthStorage } from '../../services/common-utils/common-utils';

@Component({
  selector: 'app-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {

  constructor(private readonly auth: AuthService) {}

  logout() {
    clearAuthStorage();
    this.auth.logout({
      logoutParams: { returnTo: window.location.origin }
    });
  }
}
